import { useSnackbarManager } from '@vkontakte/vkui';
import { useEffect } from 'react';
import styles from './ui.module.css';

/**
 * Всплывающая плашка: «сохранено», «не получилось», «скопировано».
 *
 * Хозяин один на приложение — `ToastHost` в каркасе. Экран не держит ни
 * состояния, ни разметки: он зовёт `toast('текст')` и всё. До этого плашку
 * заводил каждый экран сам, восемью копиями двух разных способов — где-то
 * через `useToast` с ключом и ручным закрытием, где-то через `useState` с
 * готовым `<Snackbar>` внутри, — и они уже разошлись: у одних плашка
 * перерисовывалась на каждое сообщение, у других нет.
 *
 * Очередь, безопасные поля, закрытие по свайпу и по таймеру достаются от
 * `useSnackbarManager`: свой менеджер писать незачем.
 *
 * ВИД задаётся ТОКЕНАМИ на нашем классе, а не правкой классов VKUI. `className`
 * уезжает на хост плашки, а переменные наследуются вниз, до её тела — поэтому
 * фон, скругление, тень и цвет текста получается назвать, не целясь в
 * `vkuiBasic__body`, имя которого сгенерировано и может смениться.
 */

type SnackbarApi = ReturnType<typeof useSnackbarManager>[0];

let api: SnackbarApi | null = null;

export function toast(message: string, action?: { label: string; onClick: () => void }): void {
  api?.open({
    children: message,
    className: styles.toast,
    action: action?.label,
    onActionClick: action?.onClick,
  });
}

/**
 * Ставится ОДИН раз в каркасе. Пока его нет, `toast` молчит: на старте
 * приложения показывать ещё нечего.
 */
export function ToastHost() {
  // Одна плашка за раз: экран — телефонный, две закрывают друг друга и
  // половину содержимого. Новая вытесняет старую, а не ждёт её.
  const [snackbars, host] = useSnackbarManager({ limit: 1, queueStrategy: 'shift' });

  useEffect(() => {
    api = snackbars;
    return () => {
      api = null;
    };
  }, [snackbars]);

  return host;
}
